var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.scriptText)?_c('div',{attrs:{"component":"VideoRecorderSubtitles"}},[_c('div',{ref:"scroller",staticClass:"scroller"},[_c('div',{ref:"subtitles",staticClass:"subtitles"},[_vm._v(_vm._s(_vm.scriptText))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }